import React = require("react");
import * as ReactDOM from "react-dom";

export interface ModuleActionBarContentProps extends React.Props<ModuleActionBarContent> {
    configView: HTMLElement;
}

export default class ModuleActionBarContent extends React.Component<ModuleActionBarContentProps, {}> {

    componentDidMount() {
        let configView = ReactDOM.findDOMNode(this.refs["configView"]);
        // console.log(this.props.configView);
        this.showModuleEditorContainer();
        configView.appendChild(this.props.configView);
    }

    componentDidUpdate() {
       let configView = ReactDOM.findDOMNode(this.refs["configView"]);
        // console.log(this.props.configView);
        this.showModuleEditorContainer();
        configView.appendChild(this.props.configView);
    }

    render() {
        return <div ref="configView"></div>;
    }

    private showModuleEditorContainer() {
        let moduleEditorContainer = this.props.configView.querySelector('.moduleEditorContainer') as HTMLElement;
        moduleEditorContainer.style.display = 'block';
        moduleEditorContainer.style.position = 'relative';
        let moduleEditorTitle = this.props.configView.querySelector('.diye .section-title-box') as HTMLElement;
        moduleEditorTitle.style.display = 'none';
        let moduleEditorFooter = this.props.configView.querySelector('.diye .box-footer') as HTMLElement;
        moduleEditorFooter.style.display = 'none';
        let moduleEditorHelpLink = this.props.configView.querySelector('.diye .module_help_link') as HTMLElement;
        moduleEditorHelpLink.style.display = 'none';

        let moduleOverlayGroup = this.props.configView.querySelector('.diye .module-overlay-group') as HTMLElement;
        moduleOverlayGroup.style.position = 'relative';
        moduleOverlayGroup.classList.add("open");
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/module-action-bar/components/ModuleActionBarContent.tsx
 **/